import React from 'react';
import { Link } from 'react-router-dom';
/* A 112px re-export of the brand mark: the full-size logo.jpg is 91KB
   for a 34px slot, which is the page's only real asset waste. */
import logoMark from '../../assets/images/logo-mark.jpg';
import { FOOTER } from '../data/content';

/* Quiet close: brand, three link columns, one legal line. */
export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="hs-footer">
      <div className="hs-shell hs-footer__grid">
        <div className="hs-footer__brand">
          <Link to="/" className="hs-footer__mark">
            <img src={logoMark} alt="" width="32" height="32" loading="lazy" decoding="async" />
            <span>HyrSkill</span>
          </Link>
          <p>{FOOTER.blurb}</p>
        </div>

        {FOOTER.columns.map((column) => (
          <nav className="hs-footer__col" key={column.title} aria-label={column.title}>
            <h3>{column.title}</h3>
            <ul>
              {column.links.map((link) => (
                <li key={link.label}>
                  {link.to ? (
                    <Link to={link.to}>{link.label}</Link>
                  ) : (
                    <a href={link.href}>{link.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="hs-shell hs-footer__legal">
        <p>&copy; {year} HyrSkill. All rights reserved.</p>
        <p>Where great students meet great opportunities.</p>
      </div>
    </footer>
  );
}
